import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.tsx'

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth()

  if (loading) return <div className="text-center py-8">Loading...</div>
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default PrivateRoute
